export default "__VITE_ASSET__Bo_y9RjA__"